<!-- Container -->
<div class="container-fluid cw-background">
  <!-- Header Row -->
  <div
    *ngIf="router.url.includes('/login') && router.url.includes('/forgot') && router.url.includes('/signup')"
    class="row-sticky-top"
  >
    <app-index-header></app-index-header>
  </div>

  <!-- Sidebar/Content Row -->
  <div class="row">
    <div class="wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div class="loading-indicator" *ngIf="loading$ | async">
  <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
</div>
